import { useRef, useState, useEffect } from 'react';
import '@geoapify/geocoder-autocomplete/styles/minimal.css';
import {
    GeoapifyGeocoderAutocomplete,
    GeoapifyContext
} from '@geoapify/react-geocoder-autocomplete';
import Map from './Map';
import L from 'leaflet';
import { MDBRow } from 'mdb-react-ui-kit';

const Autocomplete = (props) => {
    const key = process.env.REACT_APP_GEOAPIFY_API_KEY;
    const [addressInputValue, setAddressInputValue] = useState();
    const [map, setMap] = useState();
    const didMount = useRef(false);
    const [addrData, setAddrData] = useState({});
    const filterByCountryCode = ["cz"];
    const biasByCountryCode = ["cz"];
    const language = ["cs"];

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
        props.handler(createAddress(addrData))
    }, [addrData])

    if (map != undefined && props.mapUpdate) {
        setTimeout(function () { map.invalidateSize() }, 1000);
    }

    function createAddress(e) {
        let ulice = "", obec, obecCast, psc, lat, lon, address = "";
        //mapy.cz geolocation address
        if (e.properties == undefined) {
            if (!e.position) return "";
            (e.regionalStructure || []).forEach(val => {
                switch (val.type) {
                    case 'regional.address':
                        ulice = ulice + " " + val.name;
                        break;
                    case 'regional.street':
                        ulice = val.name + ulice;
                        break;
                    case 'regional.municipality_part':
                        // "část obce" (e.g. Číhaná) - needed or čp./ev.č. numbers stay ambiguous.
                        obecCast = val.name;
                        break;
                    case 'regional.municipality':
                        obec = val.name;
                        break;
                    default:
                        break;
                }
            })
            // Never a comma here - the string below is split on "," downstream in Step.js.
            if (obecCast && obecCast !== obec) obec = obecCast + " - " + obec;
            psc = e.zip ? e.zip.replace(/\s/g, '') : "";
            // Prefer the actual click - Mapy.cz's matched position can be a neighbouring building.
            lat = e.clickLat != undefined ? e.clickLat : e.position.lat;
            lon = e.clickLon != undefined ? e.clickLon : e.position.lon;
            address = ulice + "," + obec + "," + psc + "," + lat + "," + lon;
        } else {//geoapify geolocation address
            ulice = e.properties.street ? e.properties.street : e.properties.name;
            if (e.properties.housenumber != undefined) ulice += " " + e.properties.housenumber;
            obec = e.properties.city ? e.properties.city : "";
            psc = e.properties.postcode ? e.properties.postcode.replace(/\s/g, '') : "";
            lat = e.properties.lat;
            lon = e.properties.lon;
            address = ulice + "," + obec + "," + psc + "," + lat + "," + lon;
        }
        return address;
    }

    function mapSetHandler(map) {
        setMap(map);
    }
    function mapClickHandler(address) {
        //Reverse geolocation - geoapify
        //setAddressInputValue(address.properties.formatted);
        //setAddrData(address);

        //Reverse geolocation - mapy.cz
        setAddressInputValue(address.name + ', ' + address.location);
        setAddrData(address);
    }
    function onPlaceSelect(e) {
        if (e == undefined || e == null) return;
        map.invalidateSize(true);
        map.setView([e.properties.lat, e.properties.lon], 16)
        let addressLine = e.properties.address_line1 + ", " + e.properties.address_line2;
        L.popup().setLatLng([e.properties.lat, e.properties.lon]).setContent(addressLine).openOn(map);
        setAddrData(e);
    }
    function sortVerifiedFirst(suggestions) {
        // Verified matches first; unverified/synthesized ones kept, just pushed after.
        return [...suggestions].sort((a, b) =>
            (a.properties.nonVerifiedParts ? 1 : 0) - (b.properties.nonVerifiedParts ? 1 : 0)
        );
    }
    function formatSuggestion(feature) {
        // Full breadcrumb (street+number, town, municipality, region) - a plain street+number match
        // has no place name in address_line1 at all, so two identical streets in different towns
        // would otherwise render as identical, indistinguishable rows.
        const p = feature.properties;
        const main = p.address_line1 || p.name || p.formatted || '';
        const parts = [main];
        if (p.village && !main.includes(p.village)) parts.push(p.village);
        if (p.city && p.city !== p.village && !main.includes(p.city)) parts.push(p.city);
        if (p.county) parts.push(p.county);
        if (p.state) parts.push(p.state);
        let label = parts.join(', ');
        if (p.nonVerifiedParts && p.nonVerifiedParts.length) label += ' (nepřesná adresa)';
        return label;
    }


    return (
        <div className='mb-4'>
            <MDBRow className='mb-3' id='mapAutocompleteDiv'>
                <GeoapifyContext apiKey={key}>
                    <GeoapifyGeocoderAutocomplete
                        placeholder="Zadejte adresu"
                        value={addressInputValue}
                        filterByCountryCode={filterByCountryCode}
                        biasByCountryCode={biasByCountryCode}
                        lang={language}
                        debounceDelay='300'
                        skipIcons='true'
                        allowNonVerifiedHouseNumber='true'
                        allowNonVerifiedStreet='true'
                        suggestionsFilter={sortVerifiedFirst}
                        postprocessHook={formatSuggestion}
                        placeSelect={(e) => onPlaceSelect(e)}
                    />
                </GeoapifyContext>
            </MDBRow>
            <Map clickHandler={mapClickHandler} callbackHandler={mapSetHandler} />
        </div>
    )
}

export default Autocomplete

